import CrudRepository from './CrudRepository'

export default class RecruitmentsRepository extends CrudRepository {
  constructor () {
    super('recruitments')
  }
}
